/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aroma_Sampling_ActiveInputs */

const vi_aroma_sampling_active = /** @type {(inputs: Aroma_Sampling_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang dùng`)
};

/**

* @param {Aroma_Sampling_ActiveInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const aroma_sampling_active = /** @type {((inputs?: Aroma_Sampling_ActiveInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aroma_Sampling_ActiveInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_aroma_sampling_active(inputs)
});